import React, { useEffect, useState, useContext } from 'react';
import { ConfigContext } from '../../DynamicForm/DynamicForm'
import { SectionHeader } from '../../../../components/sectionHeader/sectionHeader'
import TextField from '../../../../components/TextField/TextField'
import './styles.scss';
import { GetLanguageText } from '../../../../languages/languages';
import { CheckLanguage } from '../../../../languages/languages';


export const AdditionalInfoSection = () => {

  const context = useContext(ConfigContext)
  const { formik, dbFormSpec, validationValues, formType, devMode } = context

  useEffect(() => {
    devMode && console.log('VALUES', formik.values, 'ERRORS', formik.errors)
  }, [formik.values])



  const languageID = CheckLanguage(dbFormSpec);


  if (languageID != "default") {

    const languageText = GetLanguageText(languageID);

    return (
      // validationValues.page.form.sections.AdditionalInfoSection.active ?
      <div id='additionalInfoSection' className='form-section'>

        <SectionHeader sectionTitle={`${languageText.additionalInfo.placeholder}`} styles={{ color: dbFormSpec.color }} />
        <label className='section-instruction subtitle1'>
        {languageText.additionalInfo.label}

        </label>
        <TextField formik={formik} fieldId={'OtherNote'} cssField={'fname-field'} label={`${languageText.additionalInfo.placeholder}`} requiredVal={false} maxLength={1000} />
      </div>
    )

  }
  else {
    return (
      // validationValues.page.form.sections.AdditionalInfoSection.active ?
      <div id='additionalInfoSection' className='form-section'>

        <SectionHeader sectionTitle={'Additional Information'} styles={{ color: dbFormSpec.color }} />
        <label className='section-instruction subtitle1'>
          Please provide any additional information pertinent to this request
        </label>
        <TextField formik={formik} fieldId={'OtherNote'} cssField={'fname-field'} label={'Additional Information (Maximum of 500 characters)'} requiredVal={false} maxLength={1000} />
      </div>
    )
  }
}

